import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getvideoAPi, createvideoAPi, uploadvideoAPi, deletevideoApi } from "../../../ApiUrl";
import { toast } from "react-toastify";
export const token = sessionStorage.getItem("accessToken")

const headers = {
    Authorization: `Bearer ${token}`,
};
// create video
export const createvideo = createAsyncThunk('createvideo/video', async (formData, { rejectWithValue }) => {
    try {
        const response = await axios.post(createvideoAPi, formData, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
export const updatevideo = createAsyncThunk('updatevideo/video', async ({selectedId, formData }, { rejectWithValue }) => {
    try {
        const response = await axios.put(`${uploadvideoAPi}/${selectedId}`, formData, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
// get video
export const getvideo = createAsyncThunk('getvideo/video', async () => {
    try {
        const response = await axios.get(`${getvideoAPi}?limit=`, { headers });
        return response.data; // Assuming your API response contains a 'videos' property
    } catch (error) {
        throw new Error(error.message);
    }
});

// delete video
export const deletevideos = createAsyncThunk('deletevideos/video', async (videoid, { rejectWithValue }) => {
    try {
        const response = await axios.delete(`${deletevideoApi}/${videoid}`, { headers });
        return response.data._id; // Assuming your API response contains a 'videoid' property
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
});



const videoSlice = createSlice({
    name: 'video',
    initialState: {
        videos: [],
        status: 'idle',
        error: null,
        message: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            //create video
            .addCase(createvideo.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createvideo.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(state.message);
                }
                state.status = 'idle';

            })
            .addCase(createvideo.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(state.error);
                }
            })
            //update video
            .addCase(updatevideo.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updatevideo.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(state.message);
                }
                state.status = 'idle';

            })
            .addCase(updatevideo.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(state.error);
                }
            })
            //getvideos
            .addCase(getvideo.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getvideo.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.videos = action.payload;
            })
            .addCase(getvideo.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            //delete videos
            .addCase(deletevideos.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deletevideos.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.videos.data = state.videos.data.filter(videos => videos.videoid !== action.payload);
                state.status = 'idle'
            })
            .addCase(deletevideos.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

export default videoSlice.reducer;
